import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_QUE_NUMBER_CONFIGURATION = gql`
  mutation createNumberQuesConfigRequest(
    $projectId: String!
    $description: String!
    $defaultValue: Int!
    $maxValue: Int!
    $minValue: Int!
  ) {
    questionConfiguration {
      createQuestionConfiguration(
        baseConfiguration: { projectId: $projectId, description: $description }
        questionConfigurationNumber: {
          defaultValue: $defaultValue
          maxValue: $maxValue
          minValue: $minValue
        }
      ) {
        id
      }
    }
  }
`;

const createNumberQuesConfigRequest = ({
  projectId,
  description,
  defaultValue,
  maxValue,
  minValue,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_QUE_NUMBER_CONFIGURATION}>
    {(createAppVersion, { loading, error, data }) => {
      const variables = {
        projectId,
        description,
        defaultValue,
        maxValue,
        minValue,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(
          data.questionConfiguration.createQuestionConfiguration.id
        );
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={createAppVersion}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createNumberQuesConfigRequest.propTypes = {
  defaultValue: PropTypes.number.isRequired,
  description: PropTypes.string.isRequired,
  maxValue: PropTypes.number.isRequired,
  minValue: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  projectId: PropTypes.string.isRequired,
};

createNumberQuesConfigRequest.defaultProps = {};

export default createNumberQuesConfigRequest;
